import { Controller } from "@hotwired/stimulus"

// Ticket picker of a ticketed event (events/_ticket_picker): a − / + stepper per ticket type,
// the running total and the buy button, enabled once at least one ticket is picked and while
// the people picked fit the spots left.
export default class extends Controller {
  static targets = ["quantity", "total", "submit", "spotsWarning"]
  static values = { max: Number, spots: Number }

  connect() {
    // Grouped like the prices next to it (number_to_currency, precision 0: "$25,000").
    this.formatter = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 })
    this.update()
  }

  increment(event) {
    this.step(event, 1)
  }

  decrement(event) {
    this.step(event, -1)
  }

  step(event, delta) {
    const input = this.quantityTargets.find((target) => target.dataset.ticketTypeId === event.params.ticketTypeId.toString())
    if (!input) return

    input.value = this.clamp(this.quantityOf(input) + delta)
    this.update()
  }

  update() {
    let total = 0
    let people = 0

    this.quantityTargets.forEach((input) => {
      const quantity = this.clamp(this.quantityOf(input))
      if (input.value !== "" && Number(input.value) !== quantity) input.value = quantity
      total += quantity * Number(input.dataset.price)
      people += quantity

      const row = input.closest("[data-ticket-row]")
      row?.querySelector("[data-step='down']")?.toggleAttribute("disabled", quantity <= 0)
      row?.querySelector("[data-step='up']")?.toggleAttribute("disabled", quantity >= this.maxValue)
    })

    const overSpots = this.hasSpotsValue && people > this.spotsValue
    this.totalTarget.textContent = `$${this.formatter.format(total)}`
    if (this.hasSpotsWarningTarget) this.spotsWarningTarget.hidden = !overSpots
    this.submitTarget.disabled = people === 0 || overSpots
  }

  quantityOf(input) {
    return parseInt(input.value, 10) || 0
  }

  clamp(quantity) {
    return Math.min(Math.max(quantity, 0), this.maxValue)
  }
}
